import { appGeneratePath } from '@/shared/lib';

/** Шаблон адреса карточки узла в разделе базы знаний */
export const KNOWLEDGE_NODE_ROUTE_PATH = '/knowledge/:id?' as const;

/** Адрес узла прежней базы знаний в её разделе */
export const buildKnowledgeNodePath = (nodeId?: number): string =>
  appGeneratePath(KNOWLEDGE_NODE_ROUTE_PATH, { id: nodeId == null ? null : String(nodeId) });
